/**
 * @generated SignedSource<<4902697a55b86c08dbb4647937b789b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BodyFormatTypeEnum = "PARAGRAPH" | "PARAGRAPHANDMEDIA" | "%future added value";
export type CustomContentInput = {
  attribs?: CustomContentInputAttributes | null | undefined;
  row?: number | null | undefined;
  type: string;
};
export type CustomContentInputAttributes = {
  infiniteAdsAfterNumber?: string | null | undefined;
  percentage?: string | null | undefined;
  tag?: string | null | undefined;
};
export type articlePageQuery$variables = {
  appConfigEntityId: string;
  bodyType?: BodyFormatTypeEnum | null | undefined;
  customContents?: ReadonlyArray<CustomContentInput | null | undefined> | null | undefined;
  entityId: string;
  entityUuid: string;
  isVideo: boolean;
};
export type articlePageQuery$data = {
  readonly article?: {
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"articleBaseAdvertisingInfoArticle" | "articleLinkingDataContent" | "articleListContent" | "articleSeoArticle" | "hooksAmpRedirectArticle" | "hooksArticleAcknowledgementGateOverlayArticle" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle">;
  };
  readonly videoContent?: {
    readonly entityId: string;
    readonly headline: string | null | undefined;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"articleBaseAdvertisingInfoArticle" | "articleLinkingDataContent" | "articleListContent" | "hooksArticleAcknowledgementGateOverlayArticle" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"articleSchemaContent" | "hooksArticlePageAdvertisementConfigArticle" | "hooksArticlePageFloatingButtonConfigArticle">;
};
export type articlePageQuery = {
  response: articlePageQuery$data;
  variables: articlePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appConfigEntityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bodyType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customContents"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isVideo"
  }
],
v1 = {
  "kind": "Variable",
  "name": "entityId",
  "variableName": "entityId"
},
v2 = {
  "fields": [
    (v1/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "filter"
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "articleBaseAdvertisingInfoArticle"
},
v5 = {
  "kind": "Variable",
  "name": "bodyType",
  "variableName": "bodyType"
},
v6 = {
  "kind": "Variable",
  "name": "customContents",
  "variableName": "customContents"
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "args": (v7/*: any*/),
  "kind": "FragmentSpread",
  "name": "articleListContent"
},
v9 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "hooksArticleAcknowledgementGateOverlayArticle"
},
v10 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "hooksTrackPageViewArticle"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentiment",
  "storageKey": null
},
v17 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Topic",
    "kind": "LinkedField",
    "name": "topics",
    "plural": true,
    "selections": (v15/*: any*/),
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v16/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleTypeSegment",
        "kind": "LinkedField",
        "name": "types",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleType",
            "kind": "LinkedField",
            "name": "value",
            "plural": true,
            "selections": (v15/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Article",
    "abstractKey": null
  }
],
v18 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "articleLinkingDataContent"
},
v19 = {
  "kind": "Variable",
  "name": "entityUuid",
  "variableName": "entityUuid"
},
v20 = [
  {
    "kind": "Literal",
    "name": "contentType",
    "value": "VIDEO"
  },
  (v2/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v25 = [
  (v12/*: any*/),
  (v14/*: any*/)
],
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v24/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableOffPlatformContent",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v34 = [
  (v33/*: any*/)
],
v35 = {
  "alias": "generic_og",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "og_image_scmp_generic"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
},
v36 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "styles": [
          "og_postmag",
          "og_image_style",
          "og_image_scmp_analysis",
          "og_image_scmp_explainer",
          "og_image_scmp_editorial",
          "og_image_scmp_fact_check",
          "og_image_scmp_live",
          "og_image_scmp_obituary",
          "og_image_scmp_opinion",
          "og_image_scmp_review",
          "og_image_scmp_series",
          "og_image_scmp_generic"
        ]
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "styles",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "style",
      "storageKey": null
    }
  ],
  "storageKey": "styles(filter:{\"styles\":[\"og_postmag\",\"og_image_style\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v38 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "768x768"
    }
  }
],
v39 = {
  "alias": null,
  "args": (v38/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSlideshow",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v47 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "bodyType"
  }
],
v48 = {
  "alias": null,
  "args": (v47/*: any*/),
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keywords",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorLocations",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLock",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "version",
      "value": 2
    }
  ],
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": "advertZone(version:2)"
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v24/*: any*/),
    (v14/*: any*/),
    (v37/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v59/*: any*/),
    (v45/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v44/*: any*/),
      "storageKey": null
    },
    (v24/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v24/*: any*/)
  ],
  "storageKey": null
},
v63 = [
  (v12/*: any*/),
  (v24/*: any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v63/*: any*/),
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v63/*: any*/),
      "storageKey": null
    },
    (v65/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v24/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    (v67/*: any*/),
    (v68/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v70 = [
  (v12/*: any*/)
],
v71 = {
  "kind": "InlineFragment",
  "selections": (v70/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v72 = {
  "kind": "InlineFragment",
  "selections": (v70/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v58/*: any*/),
    (v24/*: any*/)
  ],
  "storageKey": null
},
v74 = {
  "kind": "InlineFragment",
  "selections": [
    (v73/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v11/*: any*/),
            (v71/*: any*/),
            (v26/*: any*/),
            (v72/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v74/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v77 = [
  (v76/*: any*/)
],
v78 = {
  "kind": "InlineFragment",
  "selections": (v77/*: any*/),
  "type": "Author",
  "abstractKey": null
},
v79 = {
  "kind": "InlineFragment",
  "selections": (v77/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v13/*: any*/),
    (v62/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v75/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v81 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isSectionUnion"
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    (v14/*: any*/),
    (v29/*: any*/),
    (v13/*: any*/),
    (v62/*: any*/)
  ],
  "type": "VideoSection",
  "abstractKey": null
},
v83 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    (v58/*: any*/),
    (v13/*: any*/),
    (v62/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v75/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bio",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "SocialLink",
  "kind": "LinkedField",
  "name": "socialLinks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "class",
      "storageKey": null
    },
    (v86/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "type": "AUTHOR_IMAGE"
      }
    }
  ],
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "300x300"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v34/*: any*/),
      "storageKey": "style(filter:{\"style\":\"300x300\"})"
    }
  ],
  "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areaOfExpertise",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": (v47/*: any*/),
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v24/*: any*/),
    (v58/*: any*/)
  ],
  "storageKey": null
},
v95 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v96 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v37/*: any*/),
    (v56/*: any*/),
    (v24/*: any*/)
  ],
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v97/*: any*/),
    (v24/*: any*/)
  ],
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v32/*: any*/),
    (v24/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v100 = [
  (v58/*: any*/)
],
v101 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaywallType",
          "kind": "LinkedField",
          "name": "paywallTypes",
          "plural": true,
          "selections": (v100/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "moreOnThisArticles",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v41/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PaywallType",
      "kind": "LinkedField",
      "name": "paywallTypes",
      "plural": true,
      "selections": (v63/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v11/*: any*/),
            (v71/*: any*/),
            (v26/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v63/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v62/*: any*/),
    (v24/*: any*/),
    (v21/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        (v33/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "237x147"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v34/*: any*/),
          "storageKey": "style(filter:{\"style\":\"237x147\"})"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSegmentV2",
          "kind": "LinkedField",
          "name": "sectionsV2",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                (v95/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v25/*: any*/),
                  "type": "VideoSection",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": [
            (v86/*: any*/),
            (v37/*: any*/),
            (v96/*: any*/)
          ],
          "storageKey": null
        },
        (v11/*: any*/),
        (v92/*: any*/),
        (v98/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v28/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleTypeSegment",
              "kind": "LinkedField",
              "name": "types",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ArticleType",
                  "kind": "LinkedField",
                  "name": "value",
                  "plural": true,
                  "selections": [
                    (v14/*: any*/),
                    (v59/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v99/*: any*/)
          ],
          "type": "Article",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v58/*: any*/),
            (v64/*: any*/),
            (v66/*: any*/),
            (v69/*: any*/),
            (v101/*: any*/)
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v58/*: any*/),
        (v64/*: any*/),
        (v66/*: any*/),
        (v69/*: any*/),
        (v101/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortBio",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleSpeech",
  "kind": "LinkedField",
  "name": "articleSpeeches",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voiceName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v100/*: any*/),
          "type": "Section",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v107/*: any*/)
      ],
      "storageKey": null
    },
    (v76/*: any*/)
  ],
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "correction",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displaySlideShow",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printHeadline",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        (v95/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v15/*: any*/),
          "type": "VideoSection",
          "abstractKey": null
        },
        (v26/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v14/*: any*/),
        (v12/*: any*/),
        (v59/*: any*/),
        (v24/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v71/*: any*/),
        (v72/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v116 = {
  "kind": "InlineFragment",
  "selections": [
    (v115/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "seriesContainer",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v24/*: any*/),
    (v21/*: any*/),
    (v30/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "series",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            (v21/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                (v33/*: any*/),
                (v86/*: any*/),
                (v37/*: any*/),
                {
                  "alias": "size80x80",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "filter",
                      "value": {
                        "style": "80x80"
                      }
                    }
                  ],
                  "concreteType": "ImageStyle",
                  "kind": "LinkedField",
                  "name": "style",
                  "plural": false,
                  "selections": (v34/*: any*/),
                  "storageKey": "style(filter:{\"style\":\"80x80\"})"
                }
              ],
              "storageKey": null
            },
            (v30/*: any*/),
            (v92/*: any*/),
            (v113/*: any*/),
            (v98/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Article",
                  "kind": "LinkedField",
                  "name": "seriesContainer",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "series",
                      "plural": true,
                      "selections": [
                        (v11/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v70/*: any*/),
                          "type": "Content",
                          "abstractKey": "__isContent"
                        },
                        (v26/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v24/*: any*/)
                  ],
                  "storageKey": null
                },
                (v73/*: any*/),
                (v114/*: any*/),
                (v99/*: any*/),
                (v28/*: any*/),
                (v116/*: any*/)
              ],
              "type": "Article",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v58/*: any*/),
                (v62/*: any*/),
                (v64/*: any*/),
                (v66/*: any*/),
                (v69/*: any*/),
                (v116/*: any*/)
              ],
              "type": "BaseWithApplicationAndUrlAlias",
              "abstractKey": "__isBaseWithApplicationAndUrlAlias"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        },
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v58/*: any*/),
        (v62/*: any*/),
        (v64/*: any*/),
        (v66/*: any*/),
        (v69/*: any*/),
        (v75/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v118 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isContent"
},
v119 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    (v86/*: any*/),
    (v37/*: any*/),
    (v96/*: any*/)
  ],
  "storageKey": null
},
v120 = {
  "kind": "InlineFragment",
  "selections": [
    (v58/*: any*/),
    (v62/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v115/*: any*/),
        (v74/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v121 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v58/*: any*/),
    (v13/*: any*/),
    (v62/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/),
    (v69/*: any*/),
    (v75/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v122 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "firstTopic",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v14/*: any*/),
    (v76/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 4
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "PUBLISHED_DATE"
          }
        }
      ],
      "concreteType": "ContentConnection",
      "kind": "LinkedField",
      "name": "contents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v12/*: any*/),
                (v118/*: any*/),
                (v13/*: any*/),
                (v21/*: any*/),
                (v119/*: any*/),
                (v30/*: any*/),
                (v92/*: any*/),
                (v113/*: any*/),
                (v98/*: any*/),
                (v24/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v28/*: any*/),
                    (v114/*: any*/),
                    (v99/*: any*/),
                    (v116/*: any*/)
                  ],
                  "type": "Article",
                  "abstractKey": null
                },
                (v120/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "contents(first:4,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
    },
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v37/*: any*/),
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    (v121/*: any*/)
  ],
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "Glossary",
  "kind": "LinkedField",
  "name": "glossary",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "term",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "translation",
      "storageKey": null
    },
    (v107/*: any*/)
  ],
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v125 = {
  "alias": "coverHero",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "type": "HERO"
      }
    }
  ],
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "image(filter:{\"type\":\"HERO\"})"
},
v126 = {
  "alias": "coverDesktop",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "type": "COVER"
      }
    }
  ],
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "image(filter:{\"type\":\"COVER\"})"
},
v127 = {
  "alias": "coverMobile",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "type": "COVER_MOBILE"
      }
    }
  ],
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "image(filter:{\"type\":\"COVER_MOBILE\"})"
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relatedLinks",
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsor",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "concreteType": "PdfFile",
  "kind": "LinkedField",
  "name": "pdfFiles",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesReverseOrder",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "series",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v12/*: any*/),
        (v13/*: any*/),
        (v98/*: any*/),
        (v21/*: any*/),
        (v119/*: any*/),
        (v30/*: any*/),
        (v92/*: any*/),
        (v113/*: any*/),
        (v41/*: any*/),
        (v45/*: any*/),
        (v120/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v73/*: any*/),
            (v28/*: any*/),
            (v114/*: any*/),
            (v99/*: any*/),
            (v116/*: any*/)
          ],
          "type": "Article",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v132/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SectionSegmentV2",
              "kind": "LinkedField",
              "name": "sectionsV2",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "value",
                  "plural": true,
                  "selections": [
                    (v72/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Video",
          "abstractKey": null
        }
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    },
    (v26/*: any*/)
  ],
  "storageKey": null
},
v134 = {
  "alias": "size768x768",
  "args": (v38/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
},
v135 = {
  "alias": "styleMoreOnThisArticles",
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "moreOnThisArticles",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v24/*: any*/),
    (v121/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v24/*: any*/),
            (v97/*: any*/)
          ],
          "storageKey": null
        },
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": [
            (v33/*: any*/),
            (v86/*: any*/),
            (v37/*: any*/),
            (v134/*: any*/)
          ],
          "storageKey": null
        },
        (v30/*: any*/),
        (v11/*: any*/),
        (v92/*: any*/),
        (v113/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v114/*: any*/),
            (v99/*: any*/),
            (v28/*: any*/),
            (v116/*: any*/)
          ],
          "type": "Article",
          "abstractKey": null
        }
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "storageKey": null
},
v136 = {
  "alias": "size660w",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "660w"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"660w\"})"
},
v137 = {
  "alias": "size1320w",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1320w"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1320w\"})"
},
v138 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "landscape_250_99"
    }
  }
],
v139 = {
  "alias": "sizeLandscape250x99",
  "args": (v138/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v140 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "wide_landscape"
    }
  }
],
v141 = {
  "alias": "size1280x720",
  "args": (v140/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
},
v142 = {
  "alias": "size1676x943",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "wide_landscape_style"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"wide_landscape_style\"})"
},
v143 = {
  "alias": "size1200x800",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1200x800"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v144 = {
  "alias": "size1020x680",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1020x680"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1020x680\"})"
},
v145 = {
  "alias": "landscape250x99",
  "args": (v138/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v146 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeId",
  "storageKey": null
},
v147 = {
  "kind": "InlineFragment",
  "selections": [
    (v146/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v148 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "leadingSlides",
      "plural": true,
      "selections": [
        (v86/*: any*/),
        (v37/*: any*/),
        (v33/*: any*/),
        (v136/*: any*/),
        (v137/*: any*/),
        (v139/*: any*/),
        (v141/*: any*/),
        (v142/*: any*/),
        (v143/*: any*/),
        (v144/*: any*/),
        (v134/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v147/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v149 = {
  "kind": "InlineFragment",
  "selections": [
    (v62/*: any*/),
    (v64/*: any*/),
    (v66/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v150 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v64/*: any*/),
                (v66/*: any*/),
                (v69/*: any*/),
                (v75/*: any*/)
              ],
              "type": "BaseWithApplicationAndUrlAlias",
              "abstractKey": "__isBaseWithApplicationAndUrlAlias"
            }
          ],
          "type": "Section",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v151 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v14/*: any*/),
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    (v65/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v152 = {
  "kind": "InlineFragment",
  "selections": [
    (v146/*: any*/),
    (v132/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orientation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "MAIN_IMAGE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": "landscape",
          "args": (v140/*: any*/),
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v34/*: any*/),
          "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
        },
        {
          "alias": "portrait",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "portrait"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v34/*: any*/),
          "storageKey": "style(filter:{\"style\":\"portrait\"})"
        }
      ],
      "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoSource",
      "kind": "LinkedField",
      "name": "videoSource",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        (v37/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "articlePageQuery",
    "selections": [
      {
        "condition": "isVideo",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "article",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v8/*: any*/),
              {
                "args": (v7/*: any*/),
                "kind": "FragmentSpread",
                "name": "articleSeoArticle"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "hooksContentInterestArticle",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              },
              (v18/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "hooksAmpRedirectArticle"
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": [
              (v5/*: any*/),
              (v1/*: any*/),
              (v19/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "articleSchemaContent"
          }
        ]
      },
      {
        "condition": "isVideo",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "videoContent",
            "args": (v20/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              (v13/*: any*/),
              (v4/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "hooksContentInterestArticle",
                "selections": (v17/*: any*/),
                "args": null,
                "argumentDefinitions": []
              },
              (v18/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "appConfigEntityId",
            "variableName": "appConfigEntityId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "hooksArticlePageAdvertisementConfigArticle"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "hooksArticlePageFloatingButtonConfigArticle"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "articlePageQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "appConfigEntityId"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "AppConfigs",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v23/*: any*/),
        "storageKey": null
      },
      {
        "alias": "floatingButtonConfig",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "article_floating_button"
            }
          }
        ],
        "concreteType": "AppConfigs",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v23/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"article_floating_button\"})"
      },
      {
        "condition": "isVideo",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "article",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleTypeSegment",
                "kind": "LinkedField",
                "name": "types",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleType",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v24/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSegmentV2",
                "kind": "LinkedField",
                "name": "sectionsV2",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v25/*: any*/),
                        "type": "Section",
                        "abstractKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v21/*: any*/),
              (v30/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "authors",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v24/*: any*/),
                  (v14/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  },
                  (v33/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              (v50/*: any*/),
              (v24/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Correction",
                "kind": "LinkedField",
                "name": "corrections",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "correction",
                    "plural": false,
                    "selections": (v44/*: any*/),
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v80/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v81/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v60/*: any*/),
                              (v29/*: any*/),
                              (v13/*: any*/),
                              (v62/*: any*/)
                            ],
                            "type": "Section",
                            "abstractKey": null
                          },
                          (v82/*: any*/),
                          (v83/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v58/*: any*/),
                  (v84/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      (v85/*: any*/),
                      (v87/*: any*/),
                      (v58/*: any*/),
                      (v88/*: any*/),
                      (v89/*: any*/),
                      (v90/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v62/*: any*/),
                          (v64/*: any*/),
                          (v66/*: any*/),
                          (v69/*: any*/),
                          (v75/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      }
                    ],
                    "storageKey": null
                  },
                  (v91/*: any*/),
                  (v92/*: any*/),
                  (v93/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": (v23/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleTypeSegment",
                        "kind": "LinkedField",
                        "name": "types",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleType",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v59/*: any*/),
                              (v58/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v94/*: any*/),
                      (v102/*: any*/),
                      (v103/*: any*/),
                      (v60/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          (v104/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v105/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          (v86/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v106/*: any*/),
                      (v108/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Correction",
                        "kind": "LinkedField",
                        "name": "corrections",
                        "plural": true,
                        "selections": [
                          (v109/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v110/*: any*/),
                      (v111/*: any*/),
                      (v112/*: any*/),
                      (v117/*: any*/),
                      (v122/*: any*/),
                      (v123/*: any*/),
                      (v124/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v125/*: any*/),
                      (v126/*: any*/),
                      (v127/*: any*/),
                      (v128/*: any*/),
                      (v129/*: any*/),
                      (v130/*: any*/),
                      (v131/*: any*/),
                      (v133/*: any*/),
                      (v135/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v136/*: any*/),
                              (v137/*: any*/),
                              (v139/*: any*/),
                              (v141/*: any*/),
                              (v142/*: any*/),
                              (v143/*: any*/),
                              (v144/*: any*/),
                              (v134/*: any*/),
                              (v145/*: any*/),
                              (v96/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v148/*: any*/),
                          (v147/*: any*/),
                          (v149/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v149/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v62/*: any*/),
                      (v64/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v150/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v147/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v151/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  (v152/*: any*/)
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  (v19/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "LiveArticle",
            "kind": "LinkedField",
            "name": "liveArticle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customTimezone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LiveContent",
                "kind": "LinkedField",
                "name": "liveContents",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v41/*: any*/),
                  (v86/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": (v44/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "isVideo",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "videoContent",
            "args": (v20/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v21/*: any*/),
              (v13/*: any*/),
              (v118/*: any*/),
              (v55/*: any*/),
              (v12/*: any*/),
              (v52/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v57/*: any*/),
                  (v24/*: any*/),
                  (v58/*: any*/),
                  (v60/*: any*/),
                  (v14/*: any*/),
                  (v61/*: any*/),
                  (v80/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSegmentV2",
                "kind": "LinkedField",
                "name": "sectionsV2",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v81/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v60/*: any*/),
                          (v14/*: any*/),
                          (v29/*: any*/),
                          (v13/*: any*/),
                          (v62/*: any*/)
                        ],
                        "type": "Section",
                        "abstractKey": null
                      },
                      (v82/*: any*/),
                      (v26/*: any*/),
                      (v83/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v58/*: any*/),
              (v84/*: any*/),
              (v30/*: any*/),
              (v41/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "authors",
                "plural": true,
                "selections": [
                  (v85/*: any*/),
                  (v12/*: any*/),
                  (v87/*: any*/),
                  (v58/*: any*/),
                  (v14/*: any*/),
                  (v88/*: any*/),
                  (v89/*: any*/),
                  (v90/*: any*/),
                  (v24/*: any*/),
                  (v80/*: any*/)
                ],
                "storageKey": null
              },
              (v53/*: any*/),
              (v42/*: any*/),
              (v50/*: any*/),
              (v91/*: any*/),
              (v92/*: any*/),
              (v93/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleTypeSegment",
                    "kind": "LinkedField",
                    "name": "types",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleType",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v24/*: any*/),
                          (v14/*: any*/),
                          (v59/*: any*/),
                          (v58/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v94/*: any*/),
                  (v28/*: any*/),
                  (v102/*: any*/),
                  (v103/*: any*/),
                  (v60/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      (v104/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v105/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v40/*: any*/),
                      (v33/*: any*/),
                      (v86/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v106/*: any*/),
                  (v108/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Correction",
                    "kind": "LinkedField",
                    "name": "corrections",
                    "plural": true,
                    "selections": [
                      (v109/*: any*/),
                      (v54/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v110/*: any*/),
                  (v111/*: any*/),
                  (v112/*: any*/),
                  (v117/*: any*/),
                  (v122/*: any*/),
                  (v123/*: any*/),
                  (v124/*: any*/),
                  (v67/*: any*/),
                  (v68/*: any*/),
                  (v125/*: any*/),
                  (v126/*: any*/),
                  (v127/*: any*/),
                  (v128/*: any*/),
                  (v129/*: any*/),
                  (v130/*: any*/),
                  (v131/*: any*/),
                  (v133/*: any*/),
                  (v135/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          (v37/*: any*/),
                          (v136/*: any*/),
                          (v137/*: any*/),
                          (v139/*: any*/),
                          (v141/*: any*/),
                          (v142/*: any*/),
                          (v143/*: any*/),
                          (v144/*: any*/),
                          (v134/*: any*/),
                          (v145/*: any*/),
                          (v96/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v148/*: any*/),
                      (v147/*: any*/),
                      (v149/*: any*/)
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  },
                  (v149/*: any*/)
                ],
                "type": "Article",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v62/*: any*/),
                  (v64/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v150/*: any*/),
                          (v27/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v39/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v46/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v147/*: any*/)
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  },
                  (v151/*: any*/)
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              },
              (v152/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f7b35c468fd999dadba109a4f332e07b",
    "id": null,
    "metadata": {},
    "name": "articlePageQuery",
    "operationKind": "query",
    "text": "query articlePageQuery(\n  $appConfigEntityId: String!\n  $bodyType: BodyFormatTypeEnum\n  $customContents: [CustomContentInput]\n  $entityId: String!\n  $entityUuid: String!\n  $isVideo: Boolean!\n) {\n  article(filter: {entityId: $entityId}) @skip(if: $isVideo) {\n    ...articleBaseAdvertisingInfoArticle\n    ...articleListContent_3o8td4\n    ...articleSeoArticle_3o8td4\n    ...hooksArticleAcknowledgementGateOverlayArticle\n    ...hooksTrackPageViewArticle\n    ...hooksContentInterestArticle\n    ...articleLinkingDataContent\n    ...hooksAmpRedirectArticle\n    entityId\n    id\n  }\n  ...articleSchemaContent_mN6kk @skip(if: $isVideo)\n  videoContent: content(contentType: VIDEO, filter: {entityId: $entityId}) @include(if: $isVideo) {\n    __typename\n    headline\n    urlAlias\n    ...articleBaseAdvertisingInfoArticle\n    ...articleListContent_3o8td4\n    ...hooksArticleAcknowledgementGateOverlayArticle\n    ...hooksTrackPageViewArticle\n    ...hooksContentInterestArticle\n    ...articleLinkingDataContent\n    entityId\n    id\n  }\n  ...hooksArticlePageAdvertisementConfigArticle_1cAtZJ\n  ...hooksArticlePageFloatingButtonConfigArticle\n}\n\nfragment actionWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  ... on Article {\n    ...articleCommentsTriggerArticle\n    ...articlePrintArticle\n  }\n  ...entityLink\n}\n\nfragment appButtonContent on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment article20DateContent on Content {\n  __isContent: __typename\n  ...hooksArticleDateUtilsContent\n}\n\nfragment articleAdditionalInfoBoxArticleContent on Content {\n  __isContent: __typename\n  ...contentSchemaRenderContent\n}\n\nfragment articleAuthorBlockArticle on Article {\n  ...articleDateContent\n  ...authorNamesArticle\n  authors {\n    ...entityFollowButtonBase\n    ...authorAvatarAuthor\n    id\n  }\n  ...helpersCheckCanShowInPlusPlatformContent\n  ...helpersCheckIsPlusArticle\n  ...plusArticleAuthorBlockArticle\n  ...authorAvatarsArticle\n}\n\nfragment articleAuthorDetailsContent on Content {\n  __isContent: __typename\n  authors {\n    bio\n    entityId\n    ...authorCardAuthor\n    id\n  }\n}\n\nfragment articleBaseAdvertisingInfoArticle on Content {\n  __isContent: __typename\n  __typename\n  advertZone(version: 2)\n  entityId\n  contentLock\n  topics {\n    entityId\n    sponsor {\n      __typename\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n    paywallTypes {\n      entityId\n      id\n    }\n    ...helpersIsArchiveWallArticle\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment articleBeforeYouGoWidget on Content {\n  __isContent: __typename\n  ...beforeYouGoActionWidgetContent\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n  ...helpersUseContentSponsorContent\n}\n\nfragment articleCorrectionsWidgetArticle on Article {\n  corrections {\n    correction {\n      json\n    }\n    timestamp\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment articleDateContent on Content {\n  __isContent: __typename\n  ...defaultArticleDateContent\n  ...article20DateContent\n}\n\nfragment articleDividerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckIsStyleArticle\n}\n\nfragment articleFooterContent on Content {\n  __isContent: __typename\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...morningStudioArticleFooterContent\n  ...helpersCheckArticleIsInSectionsArticle\n}\n\nfragment articleFurtherReadingWidgetArticle on Article {\n  sponsorType\n  moreOnThisArticles {\n    ...articleWidgetContent\n    entityId\n    id\n  }\n}\n\nfragment articleHeadlineHeaderFeaturesContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n}\n\nfragment articleImageGalleryContent on Content {\n  __isContent: __typename\n  ...helpersCheckIsStyleArticle\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment articleLeadingArticle on Article {\n  entityId\n  sponsorType\n  displaySlideShow\n  ...articleLeadingImagesContent\n  ...contentCoverVideoContent\n  ...contentSchemaRenderContent\n  ...helpersIsArticleVideoAsHeroArticle\n}\n\nfragment articleLeadingImagesContent on Content {\n  __isContent: __typename\n  headline\n  images {\n    title\n    type\n    url\n    isSlideshow\n    size660w: style(filter: {style: \"660w\"}) {\n      url\n    }\n    size1320w: style(filter: {style: \"1320w\"}) {\n      url\n    }\n    sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size1676x943: style(filter: {style: \"wide_landscape_style\"}) {\n      url\n    }\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size1020x680: style(filter: {style: \"1020x680\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      title\n      type\n      url\n      size660w: style(filter: {style: \"660w\"}) {\n        url\n      }\n      size1320w: style(filter: {style: \"1320w\"}) {\n        url\n      }\n      sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n        url\n      }\n      size1280x720: style(filter: {style: \"wide_landscape\"}) {\n        url\n      }\n      size1676x943: style(filter: {style: \"wide_landscape_style\"}) {\n        url\n      }\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size1020x680: style(filter: {style: \"1020x680\"}) {\n        url\n      }\n      size768x768: style(filter: {style: \"768x768\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment articleLinkingDataContent on Content {\n  __isContent: __typename\n  urlAlias\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        urlAlias\n        urlRedirect {\n          toUrl\n          id\n        }\n      }\n      ... on VideoSection {\n        name\n        urlAlias\n        urlRedirect {\n          toUrl\n          id\n        }\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment articleListContent_3o8td4 on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  ...articleDividerArticle\n  ...articleFooterContent\n  ...articlePaginationCheckerContent\n  ...articlePaginationNavigationHistoryContent_3o8td4\n  ...articlePianoPaywallContent\n  ...articleRecommendationContent\n  ...articleRenderArticle_3o8td4\n  ...contextsArticleListContextProviderArticle\n  ...contextsContentReadMoreContextProviderContent\n  ...helpersCheckIsStyleArticle\n  ...helpersRosettaArticleContextArticle\n}\n\nfragment articleMoreOnThisListArticle on Article {\n  moreOnThisArticles {\n    ...entityLink\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    images {\n      url\n      style(filter: {style: \"237x147\"}) {\n        url\n      }\n    }\n    id\n  }\n}\n\nfragment articleMoreOnThisListStyleArticle on Article {\n  styleMoreOnThisArticles: moreOnThisArticles {\n    ...entityLink\n    ...magazinesStyleArticleMoreOnThisContentItemContent\n    entityId\n    id\n  }\n}\n\nfragment articlePaginationCheckerContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment articlePaginationNavigationHistoryContent_3o8td4 on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...hooksTrackCurrentItemBase_3o8td4\n}\n\nfragment articlePianoPaywallContent on Content {\n  __isContent: __typename\n  ...hooksPaywallPromiseContent\n}\n\nfragment articlePrintArticle on Article {\n  ...contentShareWidgetContent\n}\n\nfragment articlePrintHeadlineMessageArticle on Article {\n  printHeadline\n}\n\nfragment articleReadingTimeContent on Content {\n  __isContent: __typename\n  readingTime\n}\n\nfragment articleRecommendationContent on Content {\n  __isContent: __typename\n  entityId\n  ... on Article {\n    moreOnThisArticles {\n      entityId\n      publishedDate\n      urlAlias\n      paywallTypes {\n        entityId\n        id\n      }\n      sectionsV2 {\n        value {\n          __typename\n          ... on Section {\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n      types {\n        value {\n          entityId\n          id\n        }\n      }\n      urlRedirect {\n        toUrl\n        id\n      }\n      ...helpersCheckIsStyleArticle\n      id\n    }\n  }\n  ... on Video {\n    sectionsV2 {\n      value {\n        __typename\n        ... on VideoSection {\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ...helpersCheckIsStyleArticle\n}\n\nfragment articleRelatedTopicsContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    entityId\n    id\n  }\n}\n\nfragment articleRenderArticle_3o8td4 on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  ... on Article {\n    sponsorType\n  }\n  ...actionWidgetContent\n  ...articleAdditionalInfoBoxArticleContent\n  ...articleAuthorBlockArticle\n  ...articleAuthorDetailsContent\n  ...articleBaseAdvertisingInfoArticle\n  ...articleBeforeYouGoWidget\n  ...articleCommentsTriggerArticle\n  ...articleCorrectionsWidgetArticle\n  ...articleDateContent\n  ...articleFurtherReadingWidgetArticle\n  ...articleImageGalleryContent\n  ...articleLeadingArticle\n  ...articleMoreOnThisListArticle\n  ...articlePianoPaywallContent\n  ...articlePrintHeadlineMessageArticle\n  ...articleReadingTimeContent\n  ...articleRelatedTopicsContent\n  ...articleSectionsContent\n  ...articleSeriesArticle\n  ...articleShareWidgetArticle\n  ...articleSpeechInlineWidgetArticle\n  ...articleSpeechPlayerPortalArticle\n  ...articleSponsorContent\n  ...articleTopicContent\n  ...articleTopicFollowWidgetArticle\n  ...articleTopicsContent\n  ...articleTopicWidgetArticle\n  ...articleVocabBoxArticle\n  ...authorAvatarsArticle\n  ...authorNamesArticle\n  ...authorShortBioArticle\n  ...contentActionBarContent\n  ...contentBodyContent_3o8td4\n  ...contentHeadlineContent\n  ...contentHeadlineTagContent\n  ...contentLiveTagContent\n  ...contentReadMoreButtonContent\n  ...contentSchemaRenderContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...genericArticleContent\n  ...globalCheckerContent\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckArticleRenderTypeArticle\n  ...helpersCheckIsVideoContent\n  ...helpersGetArticleTypeArticle\n  ...helpersIsPlusInlinePaywall\n  ...infographicArticleArticle\n  ...liveArticleArticle\n  ...morningStudioArticleContent\n  ...newsletterArticleArticle\n  ...pianoIntegrationArticle\n  ...plusColumnsArticleContent\n  ...plusGenericArticleContent\n  ...postMagazineArticleContent\n  ...seriesArticleArticle\n  ...styleArticleContent\n  ...videoArticleContent\n}\n\nfragment articleSchemaContent_mN6kk on Query {\n  article(filter: {entityId: $entityId}) {\n    ...hooksContentHeadlineTagContent\n    authorLocations\n    contentLock\n    createdDate\n    headline\n    publishedDate\n    socialHeadline\n    sponsorType\n    updatedDate\n    urlAlias\n    authors {\n      location\n      name\n      types\n      urlAlias\n      id\n    }\n    body(customContents: $customContents, type: $bodyType) {\n      text\n    }\n    summary {\n      text\n    }\n    subHeadline {\n      text\n    }\n    corrections {\n      correction {\n        text\n      }\n      timestamp\n    }\n    images {\n      isSlideshow\n      height\n      width\n      url\n    }\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    types {\n      value {\n        name\n        id\n      }\n    }\n    id\n  }\n  ...liveBlogPostingLiveArticles_2w8PNF\n}\n\nfragment articleSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n      }\n      ... on VideoSection {\n        name\n        published\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment articleSeoArticle_3o8td4 on Article {\n  ...hooksArticleSeoArticle\n  ...helpersGetArticleTypeArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: $customContents, type: $bodyType) {\n    text\n  }\n  keywords\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  readingTime\n}\n\nfragment articleSeriesArticle on Article {\n  seriesContainer {\n    entityId\n    id\n  }\n  ...inlineArticleSeriesInlineArticle\n  ...carouselArticleSeriesCarouselArticle\n}\n\nfragment articleSeriesCarouselContent on Content {\n  __isContent: __typename\n  entityId\n  ... on Article {\n    seriesContainer {\n      series {\n        __typename\n        ... on Content {\n          __isContent: __typename\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      id\n    }\n  }\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...hooksContentItemProvidersContent_3n3tyT\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  ...genericArticleSpeechInlineWidgetGenericArticle\n  ...utilitiesGetHasArticleSpeechArticle\n}\n\nfragment articleSpeechPlayerPortalArticle on Article {\n  entityId\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSponsorContent on Article {\n  topics {\n    entityId\n    sponsor {\n      description {\n        json\n      }\n      ...sponsorTagSponsor\n      id\n    }\n    id\n  }\n  ...helpersUseContentSponsorContent\n  ...helpersCheckIsMainTopicContent\n  ...contentSchemaRenderContent\n}\n\nfragment articleTitleArticle on Article {\n  types {\n    value {\n      name\n      id\n    }\n  }\n  authors {\n    name\n    id\n  }\n}\n\nfragment articleTopicContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment articleTopicFollowWidgetArticle on Article {\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    disableFollow\n    entityId\n    name\n    entityUuid\n    id\n  }\n}\n\nfragment articleTopicWidgetArticle on Article {\n  entityId\n  sponsorType\n  firstTopic {\n    ...entityLink\n    ...followButtonBase\n    entityId\n    name\n    disableFollow\n    contents(first: 4, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n      edges {\n        node {\n          __typename\n          entityId\n          ...articleWidgetContent\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment articleTopicsContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    entityId\n    entityUuid\n    name\n    id\n  }\n}\n\nfragment articleVocabBoxArticle on Article {\n  glossary {\n    term\n    translation\n    description {\n      json\n    }\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment articleWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    sponsorType\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment atomsCurrentArticleAtomBase_3o8td4 on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Content {\n    __isContent: __typename\n    ...articleHeadlineHeaderFeaturesContent\n    ...articleSeoArticle_3o8td4\n    ...articleShareWidgetArticle\n    ...bookmarkHeaderFeaturesContent\n    ...commentHeaderFeaturesArticle\n    ...contentShareWidgetContent\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...hooksContentInterestArticle\n    ...hooksTrackPageViewArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseCurrentArticlePrebidConfigArticle\n    ...hooksUsePageTargetingArticle\n    ...onboardingNewsletterSubscriptionArticle\n    ...entityLinkHeaderFeaturesArticle\n    ...shareHeaderFeaturesContent\n    ...helpersRosettaArticleContextArticle\n  }\n}\n\nfragment atomsCurrentShareContentAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...contentShareWidgetContent\n  }\n  ... on Video {\n    ...contentShareWidgetContent\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment authorAvatarsArticle on Article {\n  authors {\n    entityId\n    ...entityLink\n    ...authorAvatarAuthor\n    ...entityFollowButtonBase\n    id\n  }\n}\n\nfragment authorBioAuthor on Author {\n  bio\n}\n\nfragment authorCardAuthor on Author {\n  ...styleAuthorCardAuthor\n  ...defaultAuthorCardAuthor\n  ...plusAuthorCardAuthor\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n  entityUuid\n}\n\nfragment authorNamesArticle on Article {\n  authorLocations\n  authors {\n    entityId\n    location\n    ...authorNameAuthor\n    id\n  }\n}\n\nfragment authorRoleAuthor on Author {\n  role {\n    text\n  }\n}\n\nfragment authorShortBioArticle on Article {\n  authors {\n    shortBio\n    id\n  }\n}\n\nfragment authorSocialLinksAuthor on Author {\n  socialLinks {\n    class\n    title\n    url\n  }\n}\n\nfragment beforeYouGoActionWidgetContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n  ...articlePrintArticle\n  ...articleShareWidgetArticle\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment blockquoteQuotePlusGenericArticleContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment bookmarkHeaderFeaturesContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment breadcrumbNewsletterArticleArticle on Article {\n  types {\n    value {\n      name\n      id\n    }\n  }\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n  articleSpeeches {\n    url\n    voiceName\n  }\n  images {\n    isSlideshow\n    url\n  }\n}\n\nfragment carouselArticleSeriesCarouselArticle on Article {\n  entityId\n  seriesContainer {\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    series {\n      __typename\n      ... on Content {\n        __isContent: __typename\n        entityId\n        urlAlias\n        ...articleSeriesCarouselContent\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ...entityLink\n    id\n  }\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment commentHeaderFeaturesArticle on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentBodyContent_3o8td4 on Content {\n  __isContent: __typename\n  entityId\n  body(customContents: $customContents, type: $bodyType) {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentCoverImageContent_1g6fcK on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3I6pSt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size80x80: style(filter: {style: \"80x80\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4cQ6Qu on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_gEdhx on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverVideoContent on Content {\n  __isContent: __typename\n  ... on Article {\n    multimediaEmbed {\n      json\n    }\n    ...contentSchemaRenderContent\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveArticleArticle on Article {\n  ...itemLiveArticleContentArticle\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterArticleArticle on Article {\n  entityId\n  relatedLinks\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentPublishedDateContent on Content {\n  __isContent: __typename\n  publishedDate\n}\n\nfragment contentReadMoreButtonContent on Content {\n  __isContent: __typename\n  ...appButtonContent\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentUpdatedDateContent on Content {\n  __isContent: __typename\n  updatedDate\n}\n\nfragment contextsArticleListContextProviderArticle on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment contextsContentReadMoreContextProviderContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersGetArticleTypeArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksReadMoreTypeformContent\n  ... on Article {\n    sponsorType\n  }\n}\n\nfragment defaultArticleDateContent on Content {\n  __isContent: __typename\n  ...hooksArticleDateUtilsContent\n}\n\nfragment defaultAuthorCardAuthor on Author {\n  ...authorAvatarAuthor\n  ...authorBioAuthor\n  ...authorNameAuthor\n  ...authorRoleAuthor\n  ...entityFollowButtonBase\n  ...followButtonBase\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityLinkHeaderFeaturesArticle on Article {\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n        ...entityLink\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment genericArticleContent on Content {\n  __isContent: __typename\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...articleBaseAdvertisingInfoArticle\n  ...globalCheckerContent\n  ...helpersCheckAnnouncementArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersIsLiteWallArticle\n  ...hooksContentHelperContent\n  ...shareArticle20Content\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n  ...utilitiesGetHasArticleSpeechArticle\n}\n\nfragment globalCheckerContent on Content {\n  __isContent: __typename\n  ...articlePianoPaywallContent\n}\n\nfragment headerMorningStudioArticle on Article {\n  ...articleSponsorContent\n  ...subheaderMorningStudioSubheaderContent\n  headline\n  coverDesktop: image(filter: {type: COVER}) {\n    url\n  }\n  coverMobile: image(filter: {type: COVER_MOBILE}) {\n    url\n  }\n}\n\nfragment headerNewsletterArticleArticle on Article {\n  headline\n  ...issuesNewsletterArticleArticle\n  ...breadcrumbNewsletterArticleArticle\n  ...widgetNewsletterArticleArticle\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckAnnouncementArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckArticleRenderTypeArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersCheckIsVideoContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsAmpEnabledArticle on Article {\n  entityId\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  disableOffPlatformContent\n  sponsorType\n  published\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsVideoContent on Content {\n  __isContent: __typename\n  __typename\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetPdfFileUrlArticle on Article {\n  pdfFiles {\n    url\n  }\n}\n\nfragment helpersGetVideoYoutubeIdVideo on Video {\n  youtubeId\n  videoSource {\n    id\n    type\n  }\n}\n\nfragment helpersIsArchiveWallArticle on Article {\n  createdDate\n  publishedDate\n  paywallTypes {\n    entityId\n    id\n  }\n  ...helpersIsVelocityWallArticle\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersIsLiteWallArticle on Article {\n  createdDate\n  publishedDate\n}\n\nfragment helpersIsPlusInlinePaywall on Content {\n  __isContent: __typename\n  contentLock\n  ...helpersGetArticleTypeArticle\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersIsSignInWallArticle on Article {\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersIsVelocityWallArticle on Article {\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersRosettaArticleContextArticle on Content {\n  __isContent: __typename\n  topics {\n    name\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersSendPdfFileTrackingArticle on Article {\n  entityId\n  pdfFiles {\n    name\n  }\n  ...helpersGetArticleTypeArticle\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment hooksAmpRedirectArticle on Article {\n  ...helpersCheckIsAmpEnabledArticle\n}\n\nfragment hooksArticleAcknowledgementGateOverlayArticle on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksArticlePageAdvertisementConfigArticle_1cAtZJ on Query {\n  appConfig(filter: {entityId: $appConfigEntityId}) {\n    json\n  }\n}\n\nfragment hooksArticlePageFloatingButtonConfigArticle on Query {\n  floatingButtonConfig: appConfig(filter: {entityId: \"article_floating_button\"}) {\n    json\n  }\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksContentHeadlineTagContent\n  ...helpersCheckIsAmpEnabledArticle\n  entityId\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_postmag\", \"og_image_style\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  topics {\n    name\n    id\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksContentItemProvidersContent_2aLOLQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_gEdhx\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2niEwz on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1g6fcK\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ...contentUpdatedDateContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3JkJ9S on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4cQ6Qu\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3n3tyT on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3I6pSt\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3wWJWe on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_gEdhx\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksReadMoreTypeformContent on Content {\n  __isContent: __typename\n  entityId\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment hooksSeriesArticleSectionTagArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...hooksPaywallPromiseContent\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTrackCurrentItemBase_3o8td4 on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_3o8td4\n  ...atomsCurrentShareContentAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n  headline\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  entityUuid\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Content {\n  __isContent: __typename\n  entityId\n  entityUuid\n}\n\nfragment hooksUseCurrentArticlePrebidConfigArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksUsePageTargetingArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  firstTopic {\n    name\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment infographicArticleArticle on Article {\n  ...globalCheckerContent\n  ...landingBannerInfographicArticle\n}\n\nfragment inlineArticleSeriesInlineArticle on Article {\n  entityId\n  seriesContainer {\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    series {\n      __typename\n      ... on Content {\n        __isContent: __typename\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ...entityLink\n    id\n  }\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment issuesDropdownNewsletterArticleArticle on Article {\n  entityId\n}\n\nfragment issuesNewsletterArticleArticle on Article {\n  types {\n    value {\n      entityUuid\n      id\n    }\n  }\n  ...issuesDropdownNewsletterArticleArticle\n}\n\nfragment itemLiveArticleContentArticle on Article {\n  entityId\n  sponsorType\n  urlAlias\n  ...articleImageGalleryContent\n  ...contentSchemaRenderContent\n  ...contentShareWidgetContent\n}\n\nfragment landingBannerInfographicArticle on Article {\n  ...articleSponsorContent\n  ...articleShareWidgetArticle\n  headline\n  topics {\n    ...entityLink\n    name\n    id\n  }\n  images {\n    title\n    url\n  }\n  coverHero: image(filter: {type: HERO}) {\n    url\n  }\n}\n\nfragment liveArticleArticle on Article {\n  entityId\n  entityUuid\n  ...articleImageGalleryContent\n  ...helpersCheckHasLiveTagArticle\n  ...contentLiveArticleArticle\n  ...globalCheckerContent\n  ...newsletterWidgetLiveArticleArticle\n  ...shareArticle20Content\n  ...articleBaseAdvertisingInfoArticle\n}\n\nfragment liveBlogPostingLiveArticles_2w8PNF on Query {\n  article(filter: {entityId: $entityId}) {\n    urlAlias\n    id\n  }\n  liveArticle(filter: {entityUuid: $entityUuid}) {\n    customTimezone\n    liveContents {\n      entityId\n      publishedDate\n      title\n      body {\n        text\n      }\n    }\n    id\n  }\n}\n\nfragment magazinesStyleArticleMoreOnThisContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...helpersCheckIsMainTopicContent\n  ...hooksContentItemProvidersContent_3JkJ9S\n}\n\nfragment morningStudioArticleContent on Content {\n  __isContent: __typename\n  ...globalCheckerContent\n  ...headerMorningStudioArticle\n}\n\nfragment morningStudioArticleFooterContent on Content {\n  __isContent: __typename\n  entityUuid\n  topics {\n    entityUuid\n    id\n  }\n}\n\nfragment newsletterArticleArticle on Article {\n  ...contentNewsletterArticleArticle\n  ...headerNewsletterArticleArticle\n  ...issuesNewsletterArticleArticle\n  ...widgetNewsletterArticleArticle\n}\n\nfragment newsletterWidgetLiveArticleArticle on Article {\n  ...contentNewsletterWidgetContent\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment paywallsGetArticlePaywallTagArticle on Article {\n  flag\n  topics {\n    entityId\n    id\n  }\n  ...helpersGetArticleTypeArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersIsSignInWallArticle\n  ...helpersIsArchiveWallArticle\n  ...helpersIsPlusInlinePaywall\n  ...helpersIsLiteWallArticle\n  ...helpersIsVelocityWallArticle\n}\n\nfragment pdfFileLinkPlusGenericArticleContent on Article {\n  entityId\n  ...helpersSendPdfFileTrackingArticle\n  ...helpersGetPdfFileUrlArticle\n  ...helpersGetArticleTypeArticle\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment pianoIntegrationArticle on Article {\n  __typename\n  contentLock\n  createdDate\n  entityId\n  entityUuid\n  headline\n  publishedDate\n  sponsor\n  sponsorType\n  urlAlias\n  flag\n  authors {\n    name\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        entityUuid\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    entityId\n    name\n    id\n  }\n  types {\n    value {\n      entityId\n      name\n      id\n    }\n  }\n  ...helpersAppBarVariantBase\n  ...hooksPaywallPromiseContent\n  ...helpersIsArchiveWallArticle\n  ...helpersIsVelocityWallArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckCanShowInPlusPlatformContent\n  ...shareContentUnlockedArticle\n  ...paywallsGetArticlePaywallTagArticle\n}\n\nfragment plusArticleAuthorBlockArticle on Article {\n  ...articleDateContent\n  ...authorNamesArticle\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    id\n  }\n}\n\nfragment plusArticleTitleArticle on Article {\n  ...hooksContentHelperContent\n  ...articleTitleArticle\n  ...plusArticleTypeTitleContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusAuthorCardAuthor on Author {\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  areaOfExpertise\n}\n\nfragment plusColumnsArticleContent on Content {\n  __isContent: __typename\n  ...articleTitleArticle\n  ...blockquoteQuotePlusGenericArticleContent\n  ...hooksContentHelperContent\n}\n\nfragment plusGenericArticleContent on Article {\n  entityId\n  contentLock\n  sponsorType\n  ...articleAuthorDetailsContent\n  ...articleTopicsContent\n  ...articlePianoPaywallContent\n  ...helpersGetArticleTypeArticle\n  ...helpersGetPdfFileUrlArticle\n  ...helpersSendPdfFileTrackingArticle\n  ...blockquoteQuotePlusGenericArticleContent\n  ...pdfFileLinkPlusGenericArticleContent\n  ...plusArticleTitleArticle\n  ...utilitiesGetHasArticleSpeechArticle\n}\n\nfragment popupArticle20ShareMenuContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n}\n\nfragment postMagazineArticleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n  ...genericArticleContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment seriesArticleArticle on Article {\n  entityId\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  seriesReverseOrder\n  series {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...seriesPrimaryContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...seriesBannerContent\n}\n\nfragment seriesBannerContent on Content {\n  __isContent: __typename\n  ...hooksSeriesArticleSectionTagArticle\n  ...entityLink\n  ...hooksContentItemProvidersContent_2niEwz\n  publishedDate\n  ...shareArticle20Content\n}\n\nfragment seriesPrimaryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3wWJWe\n}\n\nfragment shareArticle20Content on Content {\n  __isContent: __typename\n  ...popupArticle20ShareMenuContent\n}\n\nfragment shareContentUnlockedArticle on Article {\n  entityId\n}\n\nfragment shareHeaderFeaturesContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment styleArticleAuthorBlockArticle on Article {\n  createdDate\n  publishedDate\n  sponsorType\n  firstTopic {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  authors {\n    ...authorNameAuthor\n    entityId\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment styleArticleContent on Content {\n  __isContent: __typename\n  entityId\n  ...articleImageGalleryContent\n  ...articleMoreOnThisListStyleArticle\n  ...globalCheckerContent\n  ...styleArticleAuthorBlockArticle\n}\n\nfragment styleAuthorCardAuthor on Author {\n  ...authorSocialLinksAuthor\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  ...entityFollowButtonBase\n}\n\nfragment subheaderMorningStudioSubheaderContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n  ...articleSponsorContent\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment utilitiesGetHasArticleSpeechArticle on Article {\n  articleSpeeches {\n    url\n  }\n}\n\nfragment videoArticleContent on Video {\n  duration\n  entityId\n  headline\n  socialHeadline\n  orientation\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  image(filter: {type: MAIN_IMAGE}) {\n    landscape: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    portrait: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n  ...articleBaseAdvertisingInfoArticle\n  ...helpersGetVideoYoutubeIdVideo\n  ...shareArticle20Content\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment widgetNewsletterArticleArticle on Article {\n  relatedNewsletters {\n    ...helpersMassageToNewsletterItemNewsletter\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "68f5b418f34a378ef4540a928a8a1aa6";

export default node;
